import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { MaskMonthYear } from "beaktShared/helpers/masks";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// Outros components
import Timeline from "beaktShared/components/Timeline/Timeline.js";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import ExtratoRoyaltiesDM2 from "./ExtratoRoyaltiesDM2";

// icons
import RemoveIcon from '@material-ui/icons/Remove';
import Assignment from '@material-ui/icons/Assignment';
import DeleteIcon from '@material-ui/icons/Delete';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HistoryIcon from '@material-ui/icons/History';

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";
import { formateDateandTime } from "beaktShared/helpers/masks";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function EstornoRoyalties() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();

    const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const [aceiteFechamento, setaceiteFechamento] = React.useState("Todos");
    const [situacaoFechamento, setsituacaoFechamento] = React.useState("Todos");
    const [loading, setloading] = React.useState(false);
    const [list, setlist] = React.useState([]);

    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingEstabelecimento(false);
                return false;
            }

            let lista = [];
            lista = [{ estabelecimentoId: 0, descricao: "Todos" }, ...result.data];

            setisLoadingEstabelecimento(false);
            setestabelecimentos(lista);
            return true;
        });
    };

    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const optionsAceiteFechamento = [
        { value: 'Todos', label: t('label.all') },
        { value: 'Aceito pela Clínica', label: t('royaltie.accepted_by_establishment') },
        { value: 'Pendente de Aceite', label: t('royaltie.pending_acceptance') },
        { value: 'Fechamento Estornado', label: t('royaltie.closure_reversed') },
    ];

    const handleAceiteFechamentoChange = (value) => {
        setaceiteFechamento(value);
    };

    const optionsSituacaoFechamento = [
        { value: 'Todos', label: t('label.all') },
        { value: 'Saldo Credor', label: t('label.credit_balance') },
        { value: 'Saldo Devedor', label: t('label.outstanding_balance') },
    ];

    const handleSituacaoFechamentoChange = (value) => {
        setsituacaoFechamento(value);
    };

    const handleClickPesquisa = () => {
        clearError("mesano");
        var data = getValues();

        if (data.mesano === "") {
            return setError("mesano", t('label.required'));

        }
        if (data.mesano.length !== 7) {
            return setError("mesano", t('error_message.invalid_month_year'));
        }

        let filtro = {
            franquiaId: session.franquiaId,
            mesano: data.mesano,
            estabelecimentoId: estabelecimento,
            tipoaceite: aceiteFechamento,
            situacaoFechamento: situacaoFechamento,
        }

        setloading(true);
        UsePostApi("royalties/filterconfirmacaopagamento", filtro).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            if (result.data.length === 0) {
                showNotification(t('information_message.no_recod_found'), 'warning');
            }
            setlist(result.data);
            setloadingTable(false);
            loadDataCsv(result.data);
        });
    };

    const [showModal, setshowModal] = React.useState(false);
    const [royaltieIdExtrato, setroyaltieIdExtrato] = React.useState(0);

    const showExtrato = (idRoyaltie) => {
        setroyaltieIdExtrato(idRoyaltie);
        setshowModal(true);
    };

    const [showModalEstorno, setshowModalEstorno] = React.useState(false);
    const [royaltieIdEstorno, setroyaltieIdEstorno] = React.useState(0);
    const [loadingEstorno, setloadingEstorno] = React.useState(false);

    const showEstorno = (idRoyaltie) => {
        setroyaltieIdEstorno(idRoyaltie);
        setValue("motivoAcao", "");
        clearError("motivoAcao");
        setshowModalEstorno(true);
    };

    const handleSalvarEstorno = () => {
        const data = getValues();
        let validacao = true;
        if (!data.motivoAcao || data.motivoAcao.trim() === "") {
            setError("motivoAcao", "required", t('label.required'));
            validacao = false;
        } else if (data.motivoAcao.trim().length < 5) {
            setError("motivoAcao", "minLength", "Mínimo de 5 caracteres");
            validacao = false;
        }

        if (!validacao) return;

        setloadingEstorno(true);
        const obj = {
            RoyaltiesId: royaltieIdEstorno,
            UsuarioId: session.id,
            MotivoAcao: data.motivoAcao
        };

        UsePostApi("royalties/estornarroyalties", obj).then(result => {
            setloadingEstorno(false);
            if (result.status !== 200 && result.status !== 201) {
                showNotification(result.message, 'danger');
                return false;
            }

            if (result.data && result.data.sucesso === false) {
                showNotification(result.data.mensagem, 'danger');
                setshowModalEstorno(false);
                return false;
            }

            const msgSucesso = (result.data && result.data.mensagem) ?
                result.data.mensagem :
                (t('information_message.registered_successfully') || "Operação realizada com sucesso!");

            showNotification(msgSucesso, "success");
            setshowModalEstorno(false);
            handleClickPesquisa();
        });
    };

    const [showModalHistorico, setshowModalHistorico] = React.useState(false);
    const [historicoRoyaltie, sethistoricoRoyaltie] = React.useState([]);

    const handleHistorico = (royaltieId) => {
        UseGetApiSimple("royalties/getHistoricoRoyaltie/" + royaltieId).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            const dadosHistorico = result.data;
            const stories = [];
            let bside = false;
            for (let i = 0; i < dadosHistorico.length; i++) {
                bside = !bside;
                let dtlog = "";
                if (dadosHistorico[i].data !== null)
                    dtlog = formateDateandTime(dadosHistorico[i].data);

                let badgeColor = "info";
                if (dadosHistorico[i].tipoAcao === "Fechamento da Rede")
                    badgeColor = "success";
                else if (dadosHistorico[i].tipoAcao === "Estorno")
                    badgeColor = "warning";
                else if (dadosHistorico[i].tipoAcao === "Fechamento da Unidade")
                    badgeColor = "primary";
                else if (dadosHistorico[i].tipoAcao === "Reprocessamento")
                    badgeColor = "info";
                else if (dadosHistorico[i].tipoAcao === "Confirmação de Pagamento")
                    badgeColor = "success";
                else if (dadosHistorico[i].tipoAcao === "Prorrogação de Recebimento")
                    badgeColor = "warning";
                else if (dadosHistorico[i].tipoAcao === "Confirmar Aceite")
                    badgeColor = "success";
                else if (dadosHistorico[i].tipoAcao === "Confirmar Recebimento")
                    badgeColor = "info";

                stories.push({
                    inverted: bside,
                    badgeColor: badgeColor,
                    titleColor: badgeColor,
                    badgeIcon: HistoryIcon,
                    title: dadosHistorico[i].tipoAcao,
                    body: (
                        <div>
                            <b>Data: </b> {dtlog}
                            <br />
                            <b>Usuário:</b> {dadosHistorico[i].nomeUsuario}
                            <br />
                            <b>Motivo:</b> {dadosHistorico[i].motivo}
                        </div>
                    )
                });
            }
            sethistoricoRoyaltie(stories);
            setshowModalHistorico(true);
        });
    };

    useEffect(() => {
        LoadEstabelecimentos();
    }, []);

    // *******************************************************************************
    // ****************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimentoDescricao" },
        { displayName: "Status", id: "statusPagamento" },
        { displayName: "DataAceite", id: "dataAceite" },
        { displayName: "parcelas", id: "parcelas" },
        { displayName: "Tipo Movimento", id: "tipoMovimento" },
        { displayName: "Valor Pagamento", id: "valorPagamento" }
    ];

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ******************************
    // *******************************************************************************

    const [dataCSV, setdataCSV] = React.useState([]);
    const [loadingTable, setloadingTable] = React.useState(false);

    const loadDataCsv = (data) => {
        let dtCsv = [];
        data.map(item => {
            const valorFormatado =
                item.valorPagamento != null
                    ? "R$ " + item.valorPagamento.toFixed(2).replace('.', ',')
                    : "";
            var obj = {
                estabelecimentoDescricao: item.estabelecimentoDescricao,
                statusPagamento: item.statusPagamento,
                dataAceite: item.dataAceite,
                parcelas: item.parcelas,
                tipoMovimento: item.tipoMovimento,
                valorPagamento: valorFormatado,
            };
            dtCsv.push(obj);
        })
        setdataCSV(dtCsv);
    };

    let columnsProps = [
        {
            Header: t('label.establishment'),
            accessor: "estabelecimentoDescricao",
        },
        {
            Header: t('label.status'),
            accessor: "statusPagamento",
        },
        {
            Header: t('label.dt_accept'),
            accessor: "dataAceite",
        },
        {
            Header: t('label.parcels'),
            accessor: "parcelas",
        },
        {
            Header: t('sale.type'),
            accessor: "tipoMovimento",
        },
        {
            Header: t('label.value'),
            accessor: "valorPagamento",
            Cell: (props) => {
                if (props.value == null) return "";

                return Math.abs(props.value)
                    .toFixed(2)
                    .replace('.', ',');
            }
        },
    ]

    const columnsAcao = [
        {
            Header: "Ações",
            Cell: row => (
                <div className="actions-right">
                    {
                        <div>
                            {
                                (
                                    row.original.tipoMovimento === "Saldo Devedor" || 
                                    row.original.tipoMovimento === "Saldo Credor" ||
                                    (row.original.tipoMovimento === " " && row.original.dataAceite !== "")
                                )
                                &&
                                <>
                                    <Button
                                        justIcon
                                        round
                                        simple
                                        color="info"
                                        className="edit"
                                        onClick={e => { showExtrato(row.original.royaltieId) }}
                                    >
                                        <Tooltip
                                            title={t('register.royalties_extract')}
                                            id="tooltip-top"
                                            placement="top"
                                            classes={{ tooltip: classes.tooltip }}
                                        >
                                            <Assignment />
                                        </Tooltip>
                                    </Button>
                                    <Button
                                        justIcon
                                        round
                                        simple
                                        color="danger"
                                        className="delete"
                                        onClick={e => { showEstorno(row.original.royaltieId) }}
                                    >
                                        <Tooltip
                                            title={t('sidebar.royalties_reversal')}
                                            id="tooltip-top"
                                            placement="top"
                                            classes={{ tooltip: classes.tooltip }} >
                                            <DeleteIcon />
                                        </Tooltip>
                                    </Button>
                                </>
                            }
                            <Button
                                justIcon
                                round
                                simple
                                color="default"
                                className="edit"
                                onClick={e => { handleHistorico(row.original.royaltieId) }}
                            >
                                <Tooltip title={"Histórico de Royalties"} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                    <AccessTimeIcon style={{ color: "black" }} />
                                </Tooltip>
                            </Button>
                        </div>
                    }
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];

    let columns = [...columnsProps, ...columnsAcao];

    return (
        <>
            <div className="maxContent">
                <form className="no-print">
                    <div>
                        <div>

                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <Card>
                                        <CardHeader color="primary" icon>
                                            <CardIcon color="primary">
                                                <RemoveIcon />
                                            </CardIcon>
                                            <h4 className={classes.cardIconTitle}>
                                                {t('sidebar.royalties_reversal')}
                                            </h4>
                                        </CardHeader>
                                        <CardBody>
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} md={2}>
                                                    <FormControl fullWidth className={classes.formControl}>
                                                        <TextField
                                                            error={errors.mesano ? true : false}
                                                            variant="outlined"
                                                            inputRef={register({ required: t('label.required') })}
                                                            label={t('label.month_year') + " *"}
                                                            name="mesano"
                                                            InputProps={{ inputComponent: MaskMonthYear }}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                        {errors.mesano &&
                                                            <FormHelperText>
                                                                <span className="obg"> {errors.mesano.message}</span>
                                                            </FormHelperText>}
                                                    </FormControl>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={5}>
                                                    <FormControl fullWidth className={classes.formControl}>
                                                        <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                            {t('label.establishment')}</label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            styles={ValidSelect(errors.estabelecimento ? true : false)}
                                                            isSearchable={true}
                                                            isLoading={isLoadingEstabelecimento}
                                                            name="estabelecimento"
                                                            placeholder={t('label.all') + "..."}
                                                            options={estabelecimentos}
                                                            value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                                            getOptionLabel={({ descricao }) => descricao}
                                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                            onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                                            ref={() => register({ name: "estabelecimento" })
                                                            }
                                                        />
                                                        {errors.estabelecimento &&
                                                            <FormHelperText>
                                                                <span className="obg"> {t('label.required')} </span>
                                                            </FormHelperText>}
                                                    </FormControl>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={5}>
                                                    <FormControl fullWidth className={classes.formControl}>
                                                        <label className={"select__label"}>{t('royaltie.closing_acceptance')}</label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            styles={ValidSelect(errors.aceitefechamento ? true : false)}
                                                            isSearchable={true}
                                                            options={optionsAceiteFechamento}
                                                            name="aceitefechamento"
                                                            value={optionsAceiteFechamento.filter(({ value }) => value === aceiteFechamento)}
                                                            onChange={(option) => handleAceiteFechamentoChange(option.value !== null ? option.value : "Todos")}
                                                            placeholder={t('label.all')}
                                                            ref={() => register({ name: "aceitefechamento" })}
                                                        />
                                                    </FormControl>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={4}>
                                                    <FormControl fullWidth className={classes.formControl}>
                                                        <label className={errors.situacaoFechamento ? "select__label select__label_error" : "select__label"}>
                                                            {t('label.closing_situation')}</label>
                                                        <Select
                                                            classNamePrefix="select"
                                                            styles={ValidSelect(errors.situacaoFechamento ? true : false)}
                                                            isSearchable={true}
                                                            name="situacaofechamento"
                                                            options={optionsSituacaoFechamento}
                                                            value={optionsSituacaoFechamento.filter(({ value }) => value === situacaoFechamento)}
                                                            onChange={(option) => handleSituacaoFechamentoChange(option.value !== null ? option.value : "Todos")}
                                                            placeholder={t('label.all')}
                                                            ref={() => register({ name: "situacaofechamento" })}
                                                        />
                                                    </FormControl>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={2}>
                                                    <Button round color="primary" onClick={() => handleClickPesquisa()} >
                                                        {t('label.search')}
                                                    </Button>
                                                </GridItem>
                                                <GridItem md={12}>
                                                    {
                                                        notification.show &&
                                                        <div>
                                                            <br />
                                                            <SnackbarContent
                                                                message={notification.message}
                                                                color={notification.color}
                                                                closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                                                                close
                                                            />
                                                        </div>
                                                    }
                                                </GridItem>

                                            </GridContainer>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    {
                                                        dataCSV.length > 0 &&
                                                        <div>
                                                            <div style={{ float: 'right' }}>
                                                                <CsvDownloader
                                                                    filename="PagamentoRoyalties"
                                                                    columns={columnsCSV}
                                                                    datas={dataCSV}
                                                                    separator={";"}>
                                                                    <Button round color="default" size="sm" >CSV</Button>
                                                                </CsvDownloader>
                                                            </div><div style={{ clear: 'both' }}></div>
                                                        </div>
                                                    }
                                                </GridItem>
                                            </GridContainer>
                                            <GridContainer>
                                                <br />
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <ReactTable
                                                        loading={loading}
                                                        data={list}
                                                        columns={columns}
                                                        filterable
                                                        defaultFilterMethod={noCaseSensitive}
                                                        defaultPageSize={10}
                                                        minRows={5}
                                                        showPaginationBottom={true}
                                                        className="-striped -highlight"
                                                        previousText={t('button.previous')}
                                                        nextText={t('button.next')}
                                                        loadingText={t('label.loading') + "..."}
                                                        noDataText={t('information_message.no_records_found') + "!"}
                                                        pageText={t('label.page')}
                                                        ofText={t('label.of')}
                                                        rowsText={t('label.rows')}
                                                    />
                                                </GridItem>
                                            </GridContainer>
                                        </CardBody>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </form>
                <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalMedium }}
                    open={showModalEstorno}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setshowModalEstorno(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{ background: '#5c4477' }}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModalEstorno(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('sidebar.royalties_reversal')}</h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody}
                    >
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <br />
                                <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={errors.motivoAcao ? true : false}
                                        label={"Motivo *"}
                                        variant="outlined"
                                        defaultValue={""}
                                        InputLabelProps={{ shrink: true }}
                                        multiline
                                        rowsMax="3"
                                        rows="2"
                                        name="motivoAcao"
                                        inputRef={register({ required: true })}
                                        inputProps={{ maxLength: 512 }}
                                    />
                                    {errors.motivoAcao && <FormHelperText>
                                        <span className="obg">{t('label.required')}</span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                <center>
                                    <br />
                                    <div className={classes.textCenter}>
                                        <Button color="transparent" onClick={() => setshowModalEstorno(false)} >
                                            {t('button.cancel')}
                                        </Button>
                                        <Button onClick={() => handleSalvarEstorno()} color="primary" >
                                            {t('button.to_save')} {loadingEstorno && <div> ... {t('label.loading')}</div>}
                                        </Button>
                                    </div>
                                    <br />
                                </center>
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                </Dialog>
                {
                    showModal &&
                    <Dialog
                        classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                        open={showModal}
                        keepMounted
                        onClose={() => setshowModal(false)}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                    >
                        <DialogTitle
                            id="classic-modal-slide-title"
                            disableTypography
                            className={classes.modalHeader}
                            style={{ background: '#5c4477' }}
                        >
                            <Button
                                justIcon
                                className={classes.modalCloseButton}
                                key="close"
                                aria-label="Close"
                                color="transparent"
                                onClick={() => setshowModal(false)}
                            >
                                <Close className={classes.modalClose} />
                            </Button>
                            <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('register.royalties_extract')} </h4>
                        </DialogTitle>
                        <DialogContent
                            id="classic-modal-slide-description"
                            className={classes.modalBody} style={{ background: '#f0f0f0' }}
                        >
                            <br />
                            {
                                session.franquiaId === 3 ?
                                    <ExtratoRoyaltiesDM2 royaltieId={royaltieIdExtrato}></ExtratoRoyaltiesDM2> :
                                    <ExtratoRoyalties royaltieId={royaltieIdExtrato}></ExtratoRoyalties>
                            }
                        </DialogContent>
                    </Dialog>
                }
                <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                    open={showModalHistorico}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setshowModalHistorico(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{ background: '#5c4477' }}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModalHistorico(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{ color: 'white' }}>Histórico de Royalties </h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody} style={{ background: '#f2f2f2' }}
                    >
                        <Timeline stories={historicoRoyaltie} />
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}